
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"32","height":"32","rx":"4","fill":"#6D7580"}}),_c('path',{attrs:{"d":"M4.458 20.5l3.612-4.98v1.416L4.614 12.1h2.208l2.388 3.372-.924.012 2.352-3.384h2.112l-3.432 4.752V15.46l3.636 5.04H10.71l-2.472-3.564h.888L6.69 20.5H4.458zm9.257 0v-8.4h1.944v6.816h4.212V20.5h-6.156zm9.967.144a6.999 6.999 0 01-1.932-.264c-.616-.184-1.112-.42-1.488-.708l.66-1.464c.36.256.784.468 1.272.636.496.16.996.24 1.5.24.384 0 .692-.036.924-.108.24-.08.416-.188.528-.324a.715.715 0 00.168-.468c0-.224-.088-.4-.264-.528a2.011 2.011 0 00-.696-.324 10.5 10.5 0 00-.96-.24c-.344-.08-.692-.176-1.044-.288a4.455 4.455 0 01-.948-.432 2.18 2.18 0 01-.708-.696c-.176-.288-.264-.656-.264-1.104 0-.48.128-.916.384-1.308.264-.4.656-.716 1.176-.948.528-.24 1.188-.36 1.98-.36.528 0 1.048.064 1.56.192.512.12.964.304 1.356.552l-.6 1.476a4.91 4.91 0 00-1.176-.492 4.182 4.182 0 00-1.152-.168c-.376 0-.684.044-.924.132-.24.088-.412.204-.516.348a.768.768 0 00-.156.48c0 .216.088.392.264.528.176.128.408.232.696.312.288.08.604.16.948.24.352.08.7.172 1.044.276.352.104.672.244.96.42.288.176.52.408.696.696.184.288.276.652.276 1.092 0 .472-.132.904-.396 1.296s-.66.708-1.188.948c-.52.24-1.18.36-1.98.36z","fill":"#fff"}})])
          )
        }
      }
    